import { useMyProductContracts } from "@/api/services/main/product-contract";
import { EContractStatus } from "@/types/enum";
import { useMemo } from "react";

const SELECTABLE_CONTRACT_STATUSES: string[] = [EContractStatus.DURING_CONTRACT, EContractStatus.TRIAL];

/**
 * The org's contracts a user can actually be granted access to (during-contract / trial).
 *
 * Whether this list is empty decides if picking a product is mandatory: with no selectable contract
 * there is nothing to check, so the form (and the bulk import) must not demand one. Shares the query
 * key with `useMyProductContracts`, so no extra network round-trip.
 */
export const useSelectableProductContracts = () => {
  const { data: contracts, isLoading } = useMyProductContracts();

  const selectableContracts = useMemo(() => contracts.filter((contract) => SELECTABLE_CONTRACT_STATUSES.includes(contract.status ?? "")), [contracts]);

  return { selectableContracts, hasSelectableProductContracts: selectableContracts.length > 0, isLoading };
};
